import { useCallback, useEffect, useMemo, useRef } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { logAction, setIsFirstLoginAction } from "../../../app/appActions";
import { RouterPaths } from "../../../app/appConstants";
import { getIsFirstLoginSelector, getUserDefaultAccountCode } from "../../../app/appSelectors";
import { isClientMobile } from "../../../components/ClientInfo/ClientInfo";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";
import { logoutAction } from "../../Login/loginActions";
import { accountGetTradingTokenAction } from "../accountActions";
import { makeSelectTradingToken, makeSelectTradingTokenGetting } from "../accountSelectors";
import { TradeLoadingStyled, TradeStyled } from "./styled/TradeStyled";
import { formSearchString } from "./tradeUtils";
import { useLocation } from "react-router-dom";

function Trade(props) {
    const { locale, getLangPath } = useLangContext();
    const location = useLocation();
    const {
        logAction,
        logout,
        getTradingToken,
        isFirstLogin,
        tradingToken,
        tradingTokenGetting,
        setIsFirstLogin,
        userDefaultAccountCode,
    } = props;
    const iframeTradeAccount = useRef(isFirstLogin ? `default:${userDefaultAccountCode}` : '');
    const messageHandler = useCallback((e) => {
        if (e.type === 'message' && e.data) {
            try {
                const data = JSON.parse(e.data);
                if (['logout_success', 'logout_error', 'relogin_request'].includes(data.type)) {
                    logAction({
                        operation: 'logout',
                        source: 'DxTimeout',
                        type: data.type,
                    });
                    logout({ source: 'DxTimeout' });
                    return;
                }
                console.log('Unknown message', data);
            } catch (e) {
            }
        }
    }, [logAction, logout]);

    useEffect(() => {
        window.addEventListener('message', messageHandler, false);

        return () => {
            window.removeEventListener('message', messageHandler, false);
        }
    }, [messageHandler])

    useEffect(() => {
        getTradingToken();
    }, [getTradingToken]);

    useEffect(() => () => {
        if (isFirstLogin) {
            setIsFirstLogin(false)
        }
    }, [isFirstLogin, setIsFirstLogin]);

    const tradeSearchString = useMemo(() => formSearchString({
        token: tradingToken,
        lang: locale,
        account: iframeTradeAccount.current,
    }), [iframeTradeAccount, locale, tradingToken]);

    if (isClientMobile) {
        return <Redirect to={{
            pathname: RouterPaths.cashier,
            search: location.search,
        }}/>
    }
    return <TradeStyled>
        {!tradingTokenGetting && !tradingToken && <TradeLoadingStyled>
            {getLangPath('error.service_unavailable')}
        </TradeLoadingStyled>}
        {
            tradingToken &&
            <iframe width="100%" height="100%" frameBorder="0"
                    src={`https://trade.fx.binomo.com?${tradeSearchString}`}
                    title={'trade'}
                    data-hj-allow-iframe=""
            ></iframe>
        }
    </TradeStyled>
}

const mapStateToProps = createStructuredSelector({
    isFirstLogin: getIsFirstLoginSelector,
    tradingToken: makeSelectTradingToken(),
    tradingTokenGetting: makeSelectTradingTokenGetting(),
    userDefaultAccountCode: getUserDefaultAccountCode,
});

const mapDispatchToProps = (dispatch) => ({
    logAction: payload => dispatch(logAction(payload)),
    getTradingToken: payload => dispatch(accountGetTradingTokenAction(payload)),
    logout: payload => dispatch(logoutAction(payload)),
    setIsFirstLogin: payload => dispatch(setIsFirstLoginAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Trade);
